import Request from '../../../../src/core/gd/data/request'

export default class ApiTaskTypes {

    static saveSortPositionsTaskTypes(data: any) {
        return new Request(this, 'PUT', 'company/'+gd.companyId+'/task-types', {
            ids: data
        })
    }

    static newTaskType(values: any) {
        return new Request(this, 'POST', 'company/'+gd.companyId+'/task-types', {
            name: values.name,
            icon: values.icon
        })
    }

    /**
     * Creates a task type with the default workflow and, when `taskId` is given, its template
     * copied from that task. See docs/code/task-template-data.md of the backend for the params.
     */
    static newTaskTypeFromTemplate(params: any) {
        return new Request(this, 'POST', 'company/'+gd.companyId+'/task-types/new', params)
    }

    static deleteTaskType(id: ID) {
        return new Request(this, 'DELETE', 'company/'+gd.companyId+'/task-type/'+id)
    }

    static updateTaskTypeTemplate(id: ID, params:any) {
        return new Request(this,'PUT','company/'+gd.companyId+'/task-type/'+id+'/template', params)
    }

    static getTaskType(id: ID) {
        return new Request(this, 'GET', 'task-type/'+id)
    }

    static saveTaskAsTemplate(taskTypeId      : ID,
                              taskId          : ID | null,
                              fields          : string[] | null,
                              customFieldIds  : ID[] | null = null) {
        return new Request(this, 'POST', 'task-type/'+taskTypeId+'/template-content', {
            taskId,
            fields,
            customFieldIds,
        })
    }
}
